
export default function FeaturesSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Digital Domination?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We deliver results that matter. Our proven approach combines cutting-edge technology
            with strategic thinking to help your business succeed.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://digitaldomination.ai/wp-content/uploads/2025/08/Dan-and-Nick-1536x1536.png"
              alt="Digital Domination Team"
              className="rounded-2xl shadow-2xl w-full h-auto"
            />
          </div>
          <div className="space-y-6">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-trophy-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Proven Track Record</h3>
                <p className="text-sm text-gray-600">
                  Over 500 successful projects delivered with measurable results. Our clients see
                  average ROI increases of 300% within the first year.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-team-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Expert Team</h3>
                <p className="text-sm text-gray-600">
                  Our team of certified professionals brings decades of combined experience in
                  digital marketing, SEO, and web development.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-lightbulb-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Innovative Solutions</h3>
                <p className="text-sm text-gray-600">
                  We stay ahead of industry trends and leverage the latest technologies to give your
                  business a competitive edge.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-customer-service-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Dedicated Support</h3>
                <p className="text-sm text-gray-600">
                  24/7 customer support ensures you always have help when you need it. Your success
                  is our priority.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-orange-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Fast Implementation</h3>
              <p className="text-sm text-gray-600">
                Get your campaigns up and running quickly with our streamlined onboarding process.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-orange-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Guaranteed Results</h3>
              <p className="text-sm text-gray-600">
                We stand behind our work with performance guarantees and transparent reporting.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-price-tag-3-line text-orange-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Competitive Pricing</h3>
              <p className="text-sm text-gray-600">
                Premium services at fair prices. We offer flexible packages to fit any budget.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
